// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".easyscreen-menu--map-screen>.vm--modal>.v-modal--content>.modal-layout>.modal-layout--content{padding:0!important}", ""]);
// Exports
module.exports = exports;
